import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Rupies from "../../Assets/Images/OMS/Rupies.svg";
import PlainRight from "../../Assets/Images/OMS/PlainRight.svg";
import {
  Button,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useFormik } from "formik";
import axios from "axios";
import toast from "react-hot-toast";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  //   border: "2px solid #000",
  boxShadow: 24,
  //   pt: 2,
  //   px: 4,
  //   pb: 3,
  p: 2,
};



function AddNewPaymentDetails({ open, handleClose, getOMSData, orderId }) {

  const handleSubmit = async(values) => {
    const actioner = JSON.parse(
      localStorage.getItem("user_detail")
    ).user_name;
    const payload = {
      order_id: orderId,
      amount:values.amount ? parseFloat(values.amount) : null,
      actioner
  }
    const url = "/api/oms/payment";
    try {
    
      const {data} = await axios.post(url, payload);
      if(data.status){
        formik.resetForm();
        handleClose();
        getOMSData();
        
        toast.success(data.message);
        
      }
      else{
        
        toast.error(data.message);
      }
  
    } catch (error) {
      console.log(error);
      toast.error(error.response ? error.response.message : "Error Occured");
    }
    
    
  }


  const formik = useFormik({
    initialValues: { amount: null},
    // validate,
    onSubmit: handleSubmit,
  });

  



  return (
    <div>
      <Modal
        className="p-0"
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...style }}>
          <h5 id="child-modal-title">Add Payment Request</h5>
          <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
          <div>
            <form onSubmit={formik.handleSubmit}>
              <div className="row mt-3">
                
                <div className="">
                  <TextField
                    size="small"
                    fullWidth
                    name="amount"
                    onChange={formik.handleChange}
                    type="number" onWheel={(e) => e.target.blur()}
                    
                    label="Amount"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <img src={Rupies} alt="" />
                        </InputAdornment>
                      ),
                    }}
                  />
                  {formik.errors.amount ? (
                    <div className="text-red-600 text-sm">
                      {formik.errors.amount}
                    </div>
                  ) : null}
                </div>
              </div>
              

              
              <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
              {/*<div className="flex gap-2 justify-between">
                <h6 className="mt-1">Auto Generate Debit Note</h6>
                <img src={PlainRight} alt="" className="ms-5" />
              </div>*/}

              <div className="mt-3 flex">
            <Button
              fullWidth
              variant="contained"
              className="me-3"
              style={{ backgroundColor: "#131542" }}
              type="submit"
            >
              Add
            </Button>
            <Button
              variant="contained"
              fullWidth
              style={{ backgroundColor: "#C7081E" }}
              type="button"
              onClick={() => handleClose()}
            >
              Close
            </Button>
          </div>
            </form>
          </div>

          
        </Box>
      </Modal>
    </div>
  );
}

export default AddNewPaymentDetails;
